import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxTextBoxModule } from 'devextreme-angular';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'nida-web-chat-input',
  imports: [CommonModule, DxTextBoxModule, TranslocoPipe, DxButtonModule],
  templateUrl: './chat-input.component.html',
  styleUrl: './chat-input.component.scss',
})
export class ChatInputComponent {
  @Output() sendMessage = new EventEmitter<string>();

  protected value = '';

  protected send() {
    this.sendMessage.emit(this.value);
    this.value = '';
  }
}
